import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { SearchableSelect } from "@pdpp/lib-react";

import { css } from "../__generated-styled-system/css";
import { orgId$ } from "../features/org/state";
import type { GetOrgUnitsResponse } from "../features/org/types";
import { toUnitSelectOptions } from "../features/org/unitSelectOptions";
import { Card } from "./Card";

const unitSelectStyles = css({
  padding: "space550!",
});

const unitPickerStyles = css({
  width: "30rem",
  maxWidth: "100%",
});

const searchableSelectStyles = css({
  width: "100%!",
  alignItems: "center!",
  "& .pdpp-react-searchableSelectPopover": {
    width: "100%!",
    maxHeight: "55vh!",
  },
});

interface UnitSelectProps {
  readonly units: ReadonlyArray<GetOrgUnitsResponse>;
}

export const UnitSelect: FC<UnitSelectProps> = ({ units }) => {
  const [t] = useTranslation();

  const options = useMemo(() => toUnitSelectOptions(units), [units]);

  return (
    <div className={unitSelectStyles}>
      <Card
        title={t("labels.noUnitTitle")}
        message={t("labels.noUnitMessage")}
        content={
          <div
            id="unitSelect"
            data-testid="selectOrgNode"
            data-analytics="plan/select-unit"
            className={unitPickerStyles}
          >
            <SearchableSelect
              id="unitSelect"
              className={searchableSelectStyles}
              options={options}
              value=""
              onChange={(unitId) => {
                orgId$.value = unitId;
              }}
              ariaLabel={t("labels.selectUnitHint")}
              placeholder={t("labels.selectUnitHint")}
              searchPlaceholder={t("labels.search")}
              emptyMessage={t("labels.noData")}
            />
          </div>
        }
      />
    </div>
  );
};
